export const MAX_WEEKS = 2
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_HUMAN_SHORT = 'MMM DD, YYYY'
export const DATE_FORMAT_HUMAN_LONG = 'MMMM DD, YYYY'
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATETIME_FORMAT_SHORT = 'Y-MM-DD HH:mm:ss'
export const DATETIME_FORMAT_SHORT_WITHOUT_SECONDS = 'Y-MM-DD HH:mm'
export const DATETIME_FORMAT_LONG = 'YYYY-MM-DD HH:mm:ss.SSS'
export const TIME_FORMAT = 'H:mm'

export const EMAIL_SUPPORT = 'support@runelabs.io'
